<template>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
      :left="left"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          ref="validate-text-field"
          :value="computedDateFormatted"
          :label="titulo_label"
          :placeholder="placeholder"
          persistent-hint
          :append-icon="append_icon"
          readonly
          v-bind="$attrs"
          v-on="on"
          :clearable="clearable"
          class="font-14"
          @click:append="clickAppend()"
          @click:clear="clearDate"
        />
      </template>

      <v-date-picker
        v-model="date"
        no-title
        :min="data_minima"
        :max="data_maxima"
        @input="menu = false"
      />
    </v-menu>
</template>

<script>
import moment from 'moment';
export default {
  model: {
    prop: "model_value",
    event: "change"
  },
  props: {
    model_value: {
      type: String,
      required: true
    },
    append_icon: {
      type: String,
      default: 'mdi-calendar'
    },
    titulo_label: {
      type: String,
      default: 'Data'
    },
    data_minima: {
      type: String,
      default: ''
    },
    data_maxima: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
      required: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    left: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    date: '',
    dateFormatted: '',
    menu: false,
  }),
  computed: {
    computedDateFormatted () {
      if (!this.date) return '';
      return this.formatDate(this.date);
    },
  },

  mounted() {
    if (this.model_value.indexOf('-') != -1) this.date = this.model_value;
    if (this.model_value.indexOf('/') != -1) this.date = moment(this.model_value, 'DD/MM/YYYY').format('YYYY-MM-DD');
  },

  watch: {
    model_value (valor) {
      if (!valor) {
        this.date = '';
        this.dateFormatted = '';
        this.$emit('change-data', '');

        return;
      }

      if (valor.indexOf('-') !== -1) {
        this.date = valor;
      } else if (valor.indexOf('/') !== -1) {
        this.date = moment(valor, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      this.dateFormatted = valor;
      this.$emit('change-data', this.date);
    },
    date (valor) {
      this.$emit('change', valor || '')
      this.$emit('change-data', valor || '')
    },
    menu (valor) {
      if (valor) {
        this.$emit('change-menu-true', this.date);
      } else {
        this.$emit('change-menu-false', this.date);
      }

      this.$emit('change', this.date);
      if (!valor) this.$refs['validate-text-field'].validate(true);
    }
  },
  methods: {
    clickAppend() {
      this.menu = true;
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clearDate() {
      this.date = ''
      this.menu = false
    }
  },
}
</script>
